import * as React from 'react';
import {
    LabelLarge,
    LabelSmall,
    ParagraphSmall
} from 'baseui/typography';
import { Block } from 'baseui/block';
//
import { DeleteObjectButton } from '../components/DeleteObjectButton'
// api
import { ObjectPropertiesExplorer } from '../../features/ObjectPropertiesExplorer'
import { BacnetMapping } from '../../features/Mapping/Bacnet';



export const DetailsPanel = (props: any) => {
    return (
        <>
            <LabelLarge>Information</LabelLarge>
            <ObjectPropertiesExplorer livestate={props} schema={props.schema}></ObjectPropertiesExplorer>
            <Block justifyContent='flex-start' gridColumnGap='20px' flexDirection='row' display='flex'>
                <DeleteObjectButton resourceGroupId={props.resourceGroupId} objectName={props.name} objectId={props.id}></DeleteObjectButton>
            </Block>
            <BacnetMapping objectId={props.id} resourceGroupId={props.resourceGroupId}></BacnetMapping>

        </>
    )
}

